export { default } from './FormDialogEvent.vue'
